// api/informations.js
// 更新情報などのお知らせ関連

import axios from 'axios'
import HOST from './hosts'
import Api from './api_base'

// トークンの取得は リクエストヘッダの Authorization: Berar が無用
// リクエストの基本設定を記述する
let api = axios.create({
  'baseURL': HOST
})

export default {
  // GET: /information informationの情報を取得する
  get: () => {
    return api.get('/information')
  },
  // POST /information informationの情報を登録する
  post: (information) => {
    return Api.post('/information', information)
  },
  // PUT /information informationの情報を編集する
  put: (information) => {
    return Api.put('/information', information)
  },
  // DELETE /information informationの情報を削除する
  delete: (id) => {
    return Api.delete('/information/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/informations.js